import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";

import "./styles/globals.css";

import { Root } from "./root";
import { HomeRoute } from "./routes/home";
import { BrowseRoute } from "./routes/browse";
import { GameDetailRoute } from "./routes/game.$slug";
import { SearchRoute } from "./routes/search";
import { NotFoundRoute } from "./routes/notFound";

/**
 * React Router 7 data router. The Root layout (nav + footer + outlet) owns
 * every page via child routes.
 */
const router = createBrowserRouter([
	{
		path: "/",
		Component: Root,
		children: [
			{ index: true, Component: HomeRoute },
			{ path: "browse", Component: BrowseRoute },
			{ path: "game/:slug", Component: GameDetailRoute },
			{ path: "search", Component: SearchRoute },
			{ path: "*", Component: NotFoundRoute },
		],
	},
]);

const rootEl = document.getElementById("root");
if (!rootEl) {
	throw new Error(
		"Portal bootstrap failed: #root element missing from index.html",
	);
}

createRoot(rootEl).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
